import { render, staticRenderFns } from "./Shangpin.vue?vue&type=template&id=148535d4&"
import script from "./Shangpin.vue?vue&type=script&lang=js&"
export * from "./Shangpin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports